import { CampaignStatus } from "models";

export const ACTIVE_CAMPAIGNS_FILTER = {
  or: [
    { status: { eq: CampaignStatus.AWAITING_DELIVERY } },
    { status: { eq: CampaignStatus.PARTIALLY_DELIVERED } },
    { status: { eq: CampaignStatus.DELIVERED } },
    { status: { eq: CampaignStatus.COPY_MISSING } },
    { status: { eq: CampaignStatus.CHECKED } },
    { status: { eq: CampaignStatus.SENT_TO_PRINT } },
    { status: { eq: CampaignStatus.SCHEDULED } },
    { status: { eq: CampaignStatus.CAP_PENDING } },
    { status: { eq: CampaignStatus.CAP_APPROVED } },
    { status: { eq: CampaignStatus.CAP_REJECTED } },
    { status: { eq: CampaignStatus.CAP_PARTIALLY_REJECTED } },
    { status: { eq: CampaignStatus.API_ERROR } },
    { status: { eq: CampaignStatus.API_PENDING } },
    { status: { eq: CampaignStatus.API_PARTIALLY_REJECTED } },
    { status: { eq: CampaignStatus.API_REJECTED } },
    { status: { eq: CampaignStatus.API_APPROVED } },
    { status: { eq: CampaignStatus.ZIP_DELIVERED } },
    { status: { eq: CampaignStatus.APPROVED } },
    { status: { eq: CampaignStatus.REJECTED } },
  ],
};

export const INACTIVE_CAMPAIGNS_FILTER = {
  or: [{ status: { eq: CampaignStatus.CANCELLED } }, { status: { eq: CampaignStatus.ARCHIVED } }],
};

export const ORIGINAL_ASSETS_FILTER = {
  or: [
    { status: { eq: "ARRIVED" } },
    { status: { eq: "QC_CAUTION" } },
    { status: { eq: "QC_FAILED" } },
    { status: { eq: "QC_OK" } },
    { status: { eq: "QC_PENDING" } },
    { status: { eq: "APPROVED" } },
    { status: { eq: "PENDING" } },
    { status: { eq: "PARTIALLY_REJECTED" } },
    { status: { eq: "REJECTED" } },
    { status: { eq: "DECLINED" } },
    { status: { eq: "ORIGINAL" } },
    { status: { eq: "LOW_RESOLUTION" } },
    { status: { eq: "ZIP_OK" } },
  ],
};

export const PROCESSED_ASSETS_FILTER = {
  or: [
    { status: { eq: "PROCESSING_FAILED" } },
    { status: { eq: "PROCESSING_OK" } },
    { status: { eq: "PROCESSING_PENDING" } },
  ],
};
